import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const ResearchersPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Scientific Project (Researchers)";
  }, []);
  return <CategoryDetailTemplate />;
};

export default ResearchersPage;
